<template>
    <div>
        <div v-for="row in rows" style="clear:both;">
            <template v-for="col in columns">
                <v-size-chart-cell :cell="GetCell(row-1, col-1)"></v-size-chart-cell>
            </template>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VSizeChartCell from '@/components/sizeChart/SizeChartCell'

    export default {
        components: {
            VSizeChartCell
        },
        props: {
            cells: { type: Array, default: function () { return [] } },
            rows: { type: Number, default: 0 },
            columns: { type:Number, default: 0 }
        },
        data() {
            return {}
        },
        methods: {
            GetCell(row, col) {
                let cell;

                if(this.cells && this.cells.length > 0) {
                    cell = this.cells.filter(x => x.Row === row && x.Column === col)[0];
                }

                if(!cell) {
                    cell = { Id: "", Value : "", Row : row, Column : col };
                    this.cells.push(cell);
                }

                return cell;
            }
        },
    }
</script>

<style lang="scss">

    @import "~@/assets/scss/private";

</style>



// WEBPACK FOOTER //
// src/components/sizeChart/SizeChart.vue